import React from 'react';
import {RouteComponentProps, withRouter, Route} from 'react-router-dom';
import {NotFoundPage, RouterWrap} from '@mc/react-app-v4';
import {useAppConfig} from '@mc/react-app-base';
import {MapPage} from './pages/MapPage';
import {MapioAppLayout} from './components/MapioAppLayout';
import {DAVKY_DTM_URL, DTM_DETAIL_URL, MAPA_URL} from './const/UrlDefinitions';
import {DavkyDtmPage} from './pages/DavkyDtmPage';
import {DtmDetailPage} from './pages/DtmDetailPage';
import {preFetchtUrls} from './utils/urlRedirectUtils';
import {useAuth} from "@mc/react-auth";

const App: React.FC<RouteComponentProps> = () => {
    // @ts-ignore
    const {serverPublic} = useAppConfig();
    const {data: auth} = useAuth();
    const isDtm: boolean = auth?.roleUzivatele?.some(role => role.kod === 'dtm') ?? false;

    //tvorba url template dle generování api
    preFetchtUrls();

    return (
        <RouterWrap
            publicChildren={
                serverPublic ? (
                    <MapioAppLayout isServerPublic>
                        <Route exact path={MAPA_URL} component={MapPage} />
                        <Route exact path={'/:kodOrganizace'} component={MapPage} />
                        <Route path={'*'} key={'not-found'} component={NotFoundPage} />
                    </MapioAppLayout>
                ) : undefined
            }
            loginPageProps={serverPublic ? undefined : {appTitle: 'Mapiio'}}
        >
            {!serverPublic && (
                <MapioAppLayout isDtm={isDtm}>
                    {isDtm && <Route exact path={DAVKY_DTM_URL} component={DavkyDtmPage} />}
                    {isDtm && <Route exact path={DTM_DETAIL_URL} component={DtmDetailPage} />}
                    <Route exact path={MAPA_URL} component={MapPage} />
                    <Route path={'*'} key={'not-found'} component={NotFoundPage} />
                </MapioAppLayout>
            )}
        </RouterWrap>
    );
};

export default withRouter(App);
